import { getAvatarUrl } from '../../utils/getAvatarUrl';
import { UserInfo } from '../../utils/model';
import { graphqlQuery } from './_graphqlQuery';

const query = `query cur {
  currentUser{
    webUrl,
    avatarUrl,
    name,
    username
  }
}`;

interface UserInfoGql {
  currentUser: {
    webUrl: string;
    avatarUrl: string;
    name: string;
    username: string;
  };
}

export const getUserInfoGql = async (token: string): Promise<UserInfo> => {
  const user = await graphqlQuery<UserInfoGql>(query, {}, token);
  return {
    avatar: getAvatarUrl(user.currentUser.avatarUrl),
    url: user.currentUser.webUrl,
    name: user.currentUser.name,
    username: user.currentUser.username,
  };
};
